import React from "react";

const Grab = () => {
  return (
    <svg width="15" height="17" viewBox="0 0 15 17" fill="none">
      <path
        d="M1.88348 10.0157C3.53072 11.8915 6.06714 15.5156 6.06714 15.5156H12.3835C13 10.5 14.5 13 14.5 6.5C14.5 4.50005 12.0001 3.50005 12 5.9998V4C12 1.5 9.06714 0.765684 9.06714 3.7657C9.06714 0.265684 6.06714 0.2657 6.06714 2.76572L6.38348 7.51561L5.06714 3.2657C4.56714 1.2657 2.06714 1.7657 2.56714 3.7657L4.06714 8.2657C1.56707 5.26578 -0.116582 7.51572 1.88348 10.0157Z"
        fill="white"
      />
      <path
        d="M9.06714 3.7657C9.06714 0.265684 6.06714 0.2657 6.06714 2.76572L6.38348 7.51561L5.06714 3.2657C4.56714 1.2657 2.06714 1.7657 2.56714 3.7657C3.06714 5.2657 4.06714 8.2657 4.06714 8.2657C1.56707 5.26578 -0.116582 7.51572 1.88348 10.0157C3.53072 11.8915 6.06714 15.5156 6.06714 15.5156H12.3835C13 10.5 14.5 13 14.5 6.5C14.5 4.5 11.9999 3.5 12 6M9.06714 3.7657C9.06714 0.765684 12 1.5 12 4V6M9.06714 3.7657L9.38348 7.51561M12 7.51561V6"
        stroke="black"
      />
    </svg>
  );
};

export default Grab;
